import { Link } from "react-router-dom";
import { SITE } from "@/data/site";

// variant "light" -> for light backgrounds (logo with dark CONSTRUCTION subtext)
// variant "dark"  -> for dark backgrounds (orange wordmark)
export const Logo = ({ variant = "light", className = "h-9 md:h-11" }) => {
  const src = variant === "dark" ? SITE.logoDark : SITE.logoLight;
  return (
    <Link
      to="/"
      aria-label="Ardeca Construction — Home"
      data-testid="logo-home-link"
      className="inline-flex items-center shrink-0"
    >
      <img src={src} alt="Ardeca Construction" className={`${className} w-auto object-contain`} />
    </Link>
  );
};

export default Logo;
